import logo from '../assets/img/logo.svg'

export function Logo() {
  return <img src={logo} alt="Logo" className="logo" />
}
